// extracted by mini-css-extract-plugin
export default {"steps":"style_steps__J0EbC","lable":"style_lable__Tawh3","title":"style_title__Xi63p","desc":"style_desc__cICmm"};